import React from "react";


const max = 1080;
const min = 300;
const debug = false;

export default class VirtualPageView extends React.PureComponent {

  constructor () {
    super();

    this.state = {

      /**
       * Key: pathname
       * Value: The page top related to the path
       */
      basicPageTops: {},
      // basicPageTops: {
      //   [window.location.pathname]: 0,
      // },

      virtualPageIndex: 0,
    };

    /**
     * @type {boolean}
     */
    this.isArticle = !!document.querySelector("meta[name='page'][content='single']");

    /**
     * @see this.checkPathUpdate
     */
    this._lastCheckedPath = window.location.pathname;

    /**
     * @see this.onWindowScroll
     */
    this._lastOnWindowScrollTimeoutId = null;

    /**
     * Bind methods
     */
    this.setStateAsync = this.setStateAsync.bind(this);
    this.registerNewPageTop = this.registerNewPageTop.bind(this);
    this.getBasicPage = this.getBasicPage.bind(this);
    this.getVirtualPageHeight = this.getVirtualPageHeight.bind(this);
    this.getVirtualPage = this.getVirtualPage.bind(this);
    this.onWindowScroll = this.onWindowScroll.bind(this);
    this.checkVirtualPage = this.checkVirtualPage.bind(this);
    this.checkPathUpdate = this.checkPathUpdate.bind(this);
    this.initialize = this.initialize.bind(this);
  }

  async setStateAsync (newState) {
    await new Promise(resolve => this.setState(newState, resolve));
  }

  async registerNewPageTop (pathname, top) {
    await this.setStateAsync(prevState => {
      const basicPageTops = prevState.basicPageTops.hasOwnProperty(pathname) ? {...prevState.basicPageTops} : {...prevState.basicPageTops, [pathname]: top};
      const virtualPageIndex = this.getVirtualPage(basicPageTops[pathname]);
      return {basicPageTops, virtualPageIndex};
    });
  }

  async getBasicPage () {
    return window.location.pathname;
  }

  getVirtualPageHeight () {
    if (window.innerHeight >= max) { return max; }
    if (window.innerHeight <= min) { return min; }
    return window.innerHeight;
  }

  getVirtualPage (top) {
    const virtualPageHeight = this.getVirtualPageHeight();
    const scrollTop = document.documentElement.scrollTop;
    return Math.max(0, Math.floor((scrollTop - top) / virtualPageHeight));
  }

  /**
   * The main magic happens here.
   */
  async onWindowScroll () {
    if (typeof this._lastOnWindowScrollTimeoutId === "number") { window.clearTimeout(this._lastOnWindowScrollTimeoutId); }
    this._lastOnWindowScrollTimeoutId = window.setTimeout(() => {
      this._lastOnWindowScrollTimeoutId = null;
      this.checkVirtualPage();
    }, 500);
  }

  async checkVirtualPage () {
    const basicPage = await this.getBasicPage();
    const basicPageTop = this.state.basicPageTops[basicPage];
    if (typeof basicPageTop !== "undefined") {
      const virtualPageIndex = this.getVirtualPage(basicPageTop);
      if (virtualPageIndex !== this.state.virtualPageIndex) { this.setState({virtualPageIndex}); }
    }
  }

  async checkPathUpdate () {
    if (this._lastCheckedPath !== window.location.pathname) {
      this._lastCheckedPath = window.location.pathname;
      const articleContentDetails = document.querySelectorAll(".article-content-detail");
      const last = articleContentDetails[articleContentDetails.length - 1];
      const top = last instanceof Element ? document.documentElement.scrollTop + last.getBoundingClientRect().top : 0;
      await this.registerNewPageTop(window.location.pathname, top);
    }

    /**
     * Doubling `requestAnimationFrame`, less frequent to check.
     */
    window.requestAnimationFrame(() => window.requestAnimationFrame(this.checkPathUpdate));
  }

  /**
   * Set the initial settings
   */
  async initialize () {
    await this.setStateAsync({basicPageTops: {[window.location.pathname]: 0}, virtualPageIndex: this.getVirtualPage(0)});
    window.addEventListener("scroll", this.onWindowScroll);
    if (this.isArticle) { this.checkPathUpdate(); }
  }

  componentDidMount () {
    window.setTimeout(this.initialize, 500);
  }

  componentDidUpdate () {
    const path = decodeURI(window.location.pathname);
    const virtualPage = this.state.virtualPageIndex;
    if (typeof virtualPage === "number" && virtualPage !== 0) {
      window.dataLayer.push({
        //virtualPageTitle: `${document.title} (Virtual Page: ${virtualPage})`,
        virtualPageTitle: `${document.title} `,
        virtualPageURL: path + (path.substr(-1) === "/" ? "" : "/") + `vpv/${virtualPage}` + window.location.search,
        event: 'VirtualPageview',
      });
    }
  }

  componentWillUnmount () {
    window.removeEventListener("scroll", this.onWindowScroll);
  }

  render () {
    if (!debug) { return null; }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/VirtualPageView.js